const PATH = 'fe.components.training_catalog.template_list';

const messages = {
  ageLevelAriaLabel: {
    key: `${PATH}.age_level_aria_label`,
    defaultValue: 'Filter by age level'
  },
  ageLevelPlaceholder: {
    key: `${PATH}.age_level_placeholder`,
    defaultValue: 'Select age level(s)'
  },
  ageLevels: {
    key: `${PATH}.age_levels`,
    defaultValue: 'Filter by age level'
  },
  allAgeLevels: {
    key: `${PATH}.all_age_levels`,
    defaultValue: 'All Age Levels'
  },
  loading: {
    key: `${PATH}.loading`,
    defaultValue: 'Loading...'
  },
  notFound: {
    key: `${PATH}.not_found`,
    defaultValue:
      'We cannot find a training that matches your search and/or filter criteria.'
  },
  searchPlaceholder: {
    key: `${PATH}.search_placeholder`,
    defaultValue: 'Search by keyword or name'
  },
  selectedCount: {
    key: `${PATH}.selected_count`,
    defaultValue: '{{selected}} Selected'
  }
};

export default messages;
